<template>
  <div class="index_module-title">
    <div class="label_bar">
      <span class="text_bar">{{name}}</span>
      <span class="more" v-if="showMore" @click="tapMore">查看更多</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    initName: String,
    initShowMore: Boolean
  },
  data() {
    return {
      name: this.initName,
      showMore: this.initShowMore
    };
  },
  watch: {},
  computed: {},
  methods: {
    tapMore() {
      this.$emit("tapMy", this.name);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
/* 通用模块标题 */

.label_bar {
  position: relative;
  /* width: 100%; */
  height: 0.75rem;
  line-height: 0.75rem;
  /* margin-top: 0.375rem; */
  /* background: url("https://assets.wxmp.ruthus.com/rushixcx/label_bar-blue.png");
  background-size: 100% 100%; */
  padding-left: 10px;
}

.label_bar .text_bar {
  /* position: absolute; */
  font-size: 0.3rem;
  font-weight: 600;
  line-height: 0.5rem;
  height: 0.5rem;
  /* top: 0.125rem;
  left: 0.8125rem; */
  
}

.label_bar .more {
  font-size: 0.3rem;
  float: right;
  background: #fff;
  margin-right: 0.1rem;
  margin-top: 0.05rem;
  vertical-align: middle;
}
</style>